const localStoragePrefix = 'storeeel_introAnimationShown_';
const TTL_DAYS = 14;

export const introAnimationShownRepository = {
  set(campaignId) {
    const storageKey = `${localStoragePrefix}${campaignId}`;
    const now = new Date().getTime();
    const expiresAt = now + TTL_DAYS * 24 * 60 * 60 * 1000;
    const value = JSON.stringify({ expiresAt });
    localStorage.setItem(storageKey, value);
  },
  get(campaignId) {
    const storageKey = `${localStoragePrefix}${campaignId}`;
    const item = localStorage.getItem(storageKey);
    if (!item) return false;

    try {
      const parsed = JSON.parse(item);
      if (!parsed.expiresAt) return false;
      const now = new Date().getTime();
      if (now < parsed.expiresAt) {
        return true;
      } else {
        localStorage.removeItem(storageKey);
        return false;
      }
    } catch {
      localStorage.removeItem(storageKey);
      return false;
    }
  }
};
